import {defineStore} from "pinia";
import { ref } from "vue";
import {fetchRatingForItem, RateEntry} from "../services/user";
import config from "../config";

export const useUserStore = defineStore("user", () => {
    const rates = ref<RateEntry[]>([])

    // async function getItemRating(id: number){
    //     const record: RateEntry | undefined = rates.value.filter((row) => row.id === id).pop()
    //     if (record)
    //         return record.rating_score
    //     try{
    //         const result = await fetchRatingForItem(id)
    //         rates.value.push(result)
    //         return result.rating_score
    //     }catch (e){
    //         if (config.DEBUG){
    //             console.log("error", e)
    //         }
    //     }
    //     return 0
    // }
    //
    // function updateItemRating(id: number, rating: number){
    //     let updated = false
    //     for (let i = 0; i < rates.value.length; i++){
    //         if (rates.value[i].id === id){
    //             rates.value[i].rating_score = rating
    //             updated = true
    //             break
    //         }
    //     }
    //     if (!updated){
    //         rates.value.push({id: id, rating_score: rating})
    //     }
    // }
    async function getItemRating(id: string){
        const record: RateEntry | undefined = rates.value.filter((row) => row.url === id).pop()
        if (record)
            return record.rating
        try{
            const result = await fetchRatingForItem(id)
            rates.value.push(result)
            return result.rating
        }catch (e){
            if (config.DEBUG){
                console.log("error", e)
            }
        }
        return 0
    }

    function updateItemRating(id: string, rating: number){
        let updated = false
        for (let i = 0; i < rates.value.length; i++){
            if (rates.value[i].url === id){
                rates.value[i].rating = rating
                updated = true
                break
            }
        }
        if (!updated){
            rates.value.push({url: id, rating: rating})
        }
    }
    return {
        rates,
        getItemRating,
        updateItemRating
    }
})
